import React from 'react';
import { connect } from 'react-redux';
import {
  Cookies,
} from '@resy/ui-kitchen';
import { selectIsAuthenticated } from '../../../../../ui-kitchen/src/reducers/authTokenSlice';
import { selectIsGlobalDiningAccess, selectIsGoldCardMember } from '../../../../../ui-kitchen/src/reducers/userSlice';
import { setResyCreditCardTypes } from '../../../../../ui-kitchen/src/reducers/amexEventsSlice';
import Logger from '../../../../../ui-kitchen/src/utils/logger';
import { setFunctionalCookie } from '../../../../../ui-kitchen/src/utils/resyUCMCookieUtils';

import AmexHeader from '../AmexMarketingUtils/AmexHeader';
import AmexTerms from '../AmexMarketingUtils/AmexTerms';
import AmexFAQs from '../AmexMarketingUtils/AmexFAQs';
import AmexPlatinumNightsVenuesRefresh from './AmexPlatinumNightsVenuesRefresh';
import AmexNaaMgmComponent from '../AmexMarketingUtils/AmexNaaMgmComponent';
import AmexPlatinumNightsBanner from './AmexPlatinumNightsBanner';
import AmexPlatinumNightsHeader from './AmexPlatinumNightsHeader';
import AmexFranchiseEditorials from '../AmexMarketingUtils/AmexFranchiseEditorials';
import AmexPlatinumNightsBenefits from './AmexPlatinumNightsBenefits';

import {
  fetchS3JsonFile,
  scrollTo,
  isGDAUser,
  isSectionHidden,
  getBlogData,
} from '../AmexMarketingUtils/AmexUtils';

import { findNaaOrMgmUrl } from './PlatinumNights';

import AmexLoading from '../AmexMarketingUtils/AmexLoading';
import AmexPlatinumNightsProps from './AmexPlatinumNightsProps';
import {
  FOLDER_NAME,
  VENUES_FILE_NAME,
  NAA_SECTION,
  MGM_SECTION,
  FILE_NAME_REFRESH,
  FILE_NAME_REFRESH_V2,
} from './constants';

import {
  GDA_MEMBER,
  GDA_COOKIE_NAME,
  CMT_COOKIE_NAME,
  GOLD_CARD,
} from '../../../../../ui-kitchen/src/constants/amexConstants';

import './AmexPlatinumNights.scss';

let hashTimeout = null;

class AmexPlatinumNights extends React.Component {
  static propTypes = AmexPlatinumNightsProps;

  state = {
    contentData: {},
    hash: null,
    updatedHidePlatinumNights: false,
    updatedHideBenefits: false,
    isVenueDataLoaded: false,
    isEditorialsDataLoaded: false,
    isNaaMgmLoaded: false,
    isAllCallsCompleted: false,
    blogDataArray: [],
    venueDataValue: [],
    editorialsData: [],
  }

  componentDidMount() {
    const currentHash = (window.location.hash).replace('#', '');
    this.hashSetup();
    const {
      ResyAmexConfig: {
        baseRequestUrl,
      },
    } = this.props;
    this.fetchDataFile(baseRequestUrl, currentHash);
  }

  // eslint-disable-next-line no-unused-vars
  componentDidUpdate(prevProps, prevState) {
    const {
      isGoldUser, isUserLoggedInAsGDA, isAuthenticated, userDataInfo, isNonUS,
    } = this.props;

    const {
      contentData,
      isVenueDataLoaded,
      isEditorialsDataLoaded,
      isNaaMgmLoaded,
      isAllCallsCompleted,
      hash,
    } = this.state;

    if (prevState.hash !== hash && hash !== '') {
      window.location.hash = `#${hash}`;
    }

    if (prevState.isVenueDataLoaded !== isVenueDataLoaded
      || prevState.isEditorialsDataLoaded !== isEditorialsDataLoaded
      || prevState.isNaaMgmLoaded !== isNaaMgmLoaded) {
      this.setAllCallsCompleted(isVenueDataLoaded, isEditorialsDataLoaded, isNaaMgmLoaded);
    }

    if (prevState.isAllCallsCompleted !== isAllCallsCompleted) {
      // scroll only after all apis have run
      if (isAllCallsCompleted && hash !== '') {
        hashTimeout = setTimeout(() => scrollTo(`#${hash}`), 1000);
      }
    }
    if ((prevProps.isGoldUser !== isGoldUser
      || prevProps.isUserLoggedInAsGDA !== isUserLoggedInAsGDA
      || prevProps.isAuthenticated !== isAuthenticated)) {
      if (isGoldUser) {
        this.setPlatPageCookies(CMT_COOKIE_NAME, GOLD_CARD);
      }

      if (isUserLoggedInAsGDA) {
        this.setPlatPageCookies(GDA_COOKIE_NAME, GDA_MEMBER);
      }
    }

    if ((prevState.contentData !== contentData
      || prevProps.userDataInfo !== userDataInfo
      || prevProps.isNonUS !== isNonUS
      || prevProps.isUserLoggedInAsGDA !== isUserLoggedInAsGDA
      || prevProps.isAuthenticated !== isAuthenticated)) {
      if (contentData?.is_platinum_nights_2026_enabled) {
        this.isMGMNAAHiddenWithCardLogic(contentData, userDataInfo, isNonUS, isUserLoggedInAsGDA);
      } else {
        this.isMGMNAAHidden(contentData, userDataInfo, isNonUS, isUserLoggedInAsGDA);
      }
    }
  }

  componentWillUnmount() {
    if (this.cookieCleanup) this.cookieCleanup();
    window.removeEventListener('hashchange', this.handleHashChange, false);
    if (hashTimeout) clearTimeout(hashTimeout);
  }

  cookieCleanup = () => { };

  hashSetup = () => {
    // clearing out the hash so that the browser doesn't anchor on mount
    window.location.hash = '';
    window.addEventListener('hashchange', this.handleHashChange, false);
  };

  handleHashChange = () => {
    const currentLocationHash = (window.location.hash).replace('#', '');
    if (currentLocationHash && currentLocationHash !== '') {
      this.setState({ hash: currentLocationHash });
    }
  };

  setPlatPageCookies = (cookieName, cookieValue) => {
    try {
      this.cookieCleanup = setFunctionalCookie(cookieName, cookieValue, {
        expires: moment().add(365, 'days').toDate(),
      });
    } catch (e) {
      Logger.error(`[Platinum Nights ${cookieName}] setFunctionalCookie Error:`, e);
    }
  }

  fetchEditorials = async () => {
    const {
      ResyAmexConfig: {
        gdaEditorialApi,
      },
    } = this.props;
    const {
      contentData,
    } = this.state;

    const editorialsData = contentData?.editorials;
    const isApiFeed = editorialsData?.is_api_feed;

    if (isApiFeed) {
      const blogDataArray = await getBlogData(editorialsData, gdaEditorialApi, 'PlatinumNights');
      this.setState({ blogDataArray });
    } else {
      this.setState({ editorialsData: editorialsData?.content });
    }
  }

  fetchDataFile = async (baseRequestUrl, hash) => {
    const { dispatch } = this.props;
    const refreshData = await fetchS3JsonFile(baseRequestUrl, FOLDER_NAME, FILE_NAME_REFRESH_V2, true);
    const contentDataValue = refreshData
      ? { ...refreshData, is_platinum_nights_2026_mvp2_enabled: true }
      : await fetchS3JsonFile(baseRequestUrl, FOLDER_NAME, FILE_NAME_REFRESH, true);

    const venueDataValue = await fetchS3JsonFile(baseRequestUrl, FOLDER_NAME, VENUES_FILE_NAME, true);
    this.setState({ contentData: { ...contentDataValue, is_platinum_nights_2026_enabled: true }, hash, venueDataValue });
    this.fetchEditorials();
    const { amex_card_types: amexCardTypes } = contentDataValue;
    dispatch(setResyCreditCardTypes(amexCardTypes));
  };

  isCardOrNonCardMember = (userDataInfo, contentData, isNonUS, isUserLoggedInAsGDA) => {
    let isCardMember = false;
    const sectionNameForUrl = findNaaOrMgmUrl(window.location.pathname);

    if (contentData?.new_card_member_logic) {
      const cardNames = new Set(contentData?.card_member_names ?? []);
      const hasMatchingCard = userDataInfo?.amex_card_types?.some((card) => cardNames.has(card)) ?? false;
      if (sectionNameForUrl === MGM_SECTION && !isNonUS) {
        isCardMember = true;
      } else if (sectionNameForUrl === NAA_SECTION && !isNonUS) {
        isCardMember = false;
      } else if (sectionNameForUrl === '' && !isNonUS && hasMatchingCard) {
        isCardMember = true;
      }
    } else {
      if (sectionNameForUrl === MGM_SECTION && !isNonUS) {
        isCardMember = true;
      } else if (sectionNameForUrl === NAA_SECTION && !isNonUS) {
        isCardMember = false;
      } else if (sectionNameForUrl === '' && !isNonUS) {
        const displayMGM = (Cookies.get(CMT_COOKIE_NAME) === GOLD_CARD)
          || userDataInfo?.amex_card_types?.length > 0
          || isGDAUser(isUserLoggedInAsGDA, Cookies);
        isCardMember = !!displayMGM;
      }

      if (sectionNameForUrl === MGM_SECTION) {
        this.setPlatPageCookies(GDA_COOKIE_NAME, GDA_MEMBER);
      }
    }
    return isCardMember;
  }

  isMGMNAAHiddenWithCardLogic = (contentData, userDataInfo, isNonUS, isUserLoggedInAsGDA) => {
    let hideMGM = true;
    let hideNAA = true;

    const isCardMember = this.isCardOrNonCardMember(userDataInfo, contentData, isNonUS, isUserLoggedInAsGDA);

    if (isCardMember && !isSectionHidden(contentData, MGM_SECTION) && !isNonUS) {
      hideMGM = false;
    } else if (!isCardMember && !isSectionHidden(contentData, NAA_SECTION) && !isNonUS) {
      hideNAA = false;
    }

    this.setState({
      hideMGMState: hideMGM,
      hideNAAState: hideNAA,
      isNaaMgmLoaded: true,
      isCardMember,
    });
  }

  isMGMNAAHidden = (contentData, userDataInfo, isNonUS, isUserLoggedInAsGDA) => {
    const sectionNameForUrl = findNaaOrMgmUrl(window.location.pathname);

    let hideMGM = true;
    let hideNAA = true;

    if (sectionNameForUrl === MGM_SECTION && !isNonUS && !isSectionHidden(contentData, MGM_SECTION)) {
      hideMGM = false;
    } else if (sectionNameForUrl === NAA_SECTION && !isNonUS && !isSectionHidden(contentData, NAA_SECTION)) {
      hideNAA = false;
    } else if (sectionNameForUrl === '') {
      const displayMGM = (Cookies.get(CMT_COOKIE_NAME) === GOLD_CARD)
        || userDataInfo?.amex_card_types?.length > 0
        || isGDAUser(isUserLoggedInAsGDA, Cookies);
      hideMGM = isSectionHidden(contentData, MGM_SECTION) || isNonUS || !displayMGM;
      hideNAA = isSectionHidden(contentData, NAA_SECTION) || isNonUS || displayMGM;
    }

    if (sectionNameForUrl === MGM_SECTION) {
      this.setPlatPageCookies(GDA_COOKIE_NAME, GDA_MEMBER);
    }

    this.setState({
      hideMGMState: hideMGM,
      hideNAAState: hideNAA,
      isNaaMgmLoaded: true,
    });
  }

  componentCallback = (componentStateName, bool) => this.setState({ [componentStateName]: bool });

  setAllCallsCompleted = (isVenueDataLoaded, isEditorialsDataLoaded, isNaaMgmLoaded) => {
    const isLoaded = (isVenueDataLoaded && isEditorialsDataLoaded && isNaaMgmLoaded);
    this.setState({ isAllCallsCompleted: isLoaded });
  };

  render() {
    const {
      Analytics,
      isAuthenticated,
      isNonUS,
      $rootScope,
      $routeParams,
      $location,
      ResyAmexConfig: {
        baseRequestUrl,
        gdaEditorialApi,
      },
      loadNotifyModal,
      showAuthModal,
    } = this.props;

    const {
      contentData,
      hash,
      hideNAAState,
      hideMGMState,
      updatedHidePlatinumNights,
      updatedHideBenefits,
      blogDataArray,
      venueDataValue,
      editorialsData,
      isCardMember,
    } = this.state;

    if (contentData === null || Object.keys(contentData).length === 0) return <AmexLoading />;
    const {
      aws_folder_name: awsFolderName,
      is_page_enabled: isPageEnabled,
      resy_header: resyHeaderConfig,
      header,
      banner,
      venues: venuesConfig,
      naa,
      mgm,
      editorials,
      benefits,
      terms,
      faqs,
      is_platinum_nights_2026_enabled: isPlatinumNights2026Enabled,
      is_platinum_nights_2026_mvp2_enabled: isPlatinumNights2026Mvp2Enabled,
      resycredit_venues: resyCreditContent,
    } = contentData;

    if (!isPageEnabled) {
      // 404 error page
      window.location.pathname = '/404';
      return null;
    }

    const hidePlatinumNights = contentData?.venues?.hide_section || updatedHidePlatinumNights;
    const hideBanner = contentData?.banner?.hide_section;
    const hideFAQs = contentData?.faqs?.hide_section;
    const hideEditorials = editorials.hide_section;
    const hideBenefits = benefits.hide_section || updatedHideBenefits;
    const editorialsImagePath = `${baseRequestUrl}${awsFolderName}/editorialImages/`;

    return (
      <section className="AmexPlatinumNights">
        <AmexHeader
          Analytics={Analytics}
          isAuthenticated={isAuthenticated}
          isNonUSLocation={isNonUS}
          $rootScope={$rootScope}
          $routeParams={$routeParams}
          $location={$location}
          matchMedia={$rootScope?.matchMedia}
          resyHeaderConfig={resyHeaderConfig}
        />
        <AmexPlatinumNightsHeader
          Analytics={Analytics}
          headerConfig={header}
          hideFAQs={hideFAQs}
          hideBenefits={hideBenefits}
          hidePlatNights={hidePlatinumNights}
          matchMedia={$rootScope?.matchMedia}
        />
        {!hideBanner && !isPlatinumNights2026Mvp2Enabled && (
          <AmexPlatinumNightsBanner
            awsFolderName={awsFolderName}
            baseRequestUrl={baseRequestUrl}
            bannerConfig={banner}
            matchMedia={$rootScope?.matchMedia}
          />
        )}
        { isPlatinumNights2026Enabled && !hidePlatinumNights && (
          <AmexPlatinumNightsVenuesRefresh
            Analytics={Analytics}
            awsFolderName={awsFolderName}
            baseRequestUrl={baseRequestUrl}
            venuesConfig={venuesConfig}
            loadNotifyModal={loadNotifyModal}
            showAuthModal={showAuthModal}
            componentCallback={this.componentCallback}
            venueDataValue={venueDataValue}
            matchMedia={$rootScope?.matchMedia}
            resyCreditContent={resyCreditContent}
            $rootScope={$rootScope}
            $routeParams={$routeParams}
            isCardMember={isCardMember}
          />
        )}
        {!hideBenefits && !isPlatinumNights2026Mvp2Enabled && (
          <AmexPlatinumNightsBenefits
            Analytics={Analytics}
            awsFolderName={awsFolderName}
            baseRequestUrl={baseRequestUrl}
            benefitsConfig={benefits}
            matchMedia={$rootScope?.matchMedia}
            componentCallback={this.componentCallback}
          />
        )}
        {!hideNAAState && !isPlatinumNights2026Mvp2Enabled && (
          <AmexNaaMgmComponent
            awsFolderName={awsFolderName}
            baseRequestUrl={baseRequestUrl}
            matchMedia={$rootScope?.matchMedia}
            sectionConfig={naa}
            eventAnalytics={Analytics.event}
            isNAA
          />
        )}
        {!hideMGMState && !isPlatinumNights2026Mvp2Enabled && (
          <AmexNaaMgmComponent
            awsFolderName={awsFolderName}
            baseRequestUrl={baseRequestUrl}
            matchMedia={$rootScope?.matchMedia}
            sectionConfig={mgm}
            eventAnalytics={Analytics.event}
            isNAA={false}
          />
        )}
        {!hideEditorials && !isPlatinumNights2026Mvp2Enabled && (
          <AmexFranchiseEditorials
            Analytics={Analytics}
            baseRequestUrl={baseRequestUrl}
            editorialsConfig={editorials}
            matchMedia={$rootScope?.matchMedia}
            editorialsData={editorialsData}
            editorialsImagePath={editorialsImagePath}
            blogDataArray={blogDataArray}
            gdaEditorialApi={gdaEditorialApi}
            selectedCityCode="all"
            componentCallback={this.componentCallback}
          />
        )}
        {!hideFAQs && (
          <AmexFAQs
            faqsConfig={faqs}
            handleTagging={() => { }}
            eventAnalytics={Analytics.event}
          />
        )}
        <AmexTerms
          baseRequestUrl={baseRequestUrl}
          termsConfig={terms}
          Analytics={Analytics}
          hash={hash}
        />
      </section>
    );
  }
}

const mapStateToProps = (state) => ({
  isAuthenticated: selectIsAuthenticated(state),
  isUserLoggedInAsGDA: selectIsGlobalDiningAccess(state),
  isGoldUser: selectIsGoldCardMember(state),
  isNonUS: state.ipdata?.isNonUS,
  userDataInfo: state.user?.userData,
});

AmexPlatinumNights.displayName = 'AmexPlatinumNights';
export { AmexPlatinumNights as ComponentAmexPlatinumNightsUnderTest, mapStateToProps };
export default connect(mapStateToProps)(AmexPlatinumNights);
